// extracted by mini-css-extract-plugin
export default {"lineaGris":"Balance_lineaGris__fCJol","rectanglesContainer":"Balance_rectanglesContainer__iHYqO","rectangle":"Balance_rectangle__S+YCq","activeButton":"Balance_activeButton__Qz6U+"};